import React from 'react';
import { visitIconsAndColors } from '../../context/visitContext';
import Icon from '../Icon/Icon';
import VisitStatus from '../VisitStatus/VisitStatus';

interface Props {
  title: string;
  iconType: string;
  date: string;
  status: 'pending' | 'completed' | 'requested' | 'sent-to-lab' | 'received-report' | undefined;
  onVisitClicked: () => void;
  disabled?: boolean;
}

function VisitItem({ title, iconType, date, status, onVisitClicked, disabled }: Props) {
  return (
    <div role="presentation" className="py-3" onClick={onVisitClicked}>
      <div
        className={`laptop:grid laptop:grid-cols-5 flex justify-between py-1  ${
          !disabled ? 'group cursor-pointer hover:bg-[#F6FAFF] hover:rounded-full' : ''
        }`}
      >
        <div className="col-span-2 flex items-center laptop:space-x-8 space-x-4">
          <div
            style={{
              backgroundColor: visitIconsAndColors[iconType]?.bgColor || '#FFE0E3',
            }}
            className="w-[50px] h-[50px] rounded-full flex items-center justify-center"
          >
            <Icon
              className={`icon-visit icon-${iconType}-visit`}
              id={visitIconsAndColors[iconType]?.icon || ''}
              style={{
                color: visitIconsAndColors[iconType]?.color || '',
              }}
            />
          </div>
          <div>
            <div className="text-river-black font-medium text-sm">{title}</div>
            <div className="text-[#737373] font-normal text-xs laptop:hidden">{date}</div>
          </div>
        </div>

        <div
          className={`${
            status === undefined ? 'col-span-2' : ''
          } laptop:flex items-center text-[#737373] font-normal text-sm hidden`}
        >
          {date}
        </div>

        {status && <div className="flex items-center">{VisitStatus[status]}</div>}

        <div className="laptop:flex items-center hidden ">
          <Icon id="iconArrowForward" className="w-4 text-[#737373] group-hover:text-river-black" />
        </div>
      </div>
    </div>
  );
}

VisitItem.defaultProps = {
  disabled: false,
};

export default VisitItem;
